
export enum FieldDataType {
    date,
    dateTime,
    text,
    enum,
    number,
    boolean
}
